// Querys and Mutations
import {
    ALL_ACTIVE
} from '@/graphql/config/HeadquarterGraphql'

// models
import { HeadquarterInterface } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class HeadquarterService {
    async getAllActivate (): Promise<HeadquarterInterface[]> {
        const result = await apolloClient.query({
            query: ALL_ACTIVE
        })
        return result.data.headquarterActive
    }
}

export default new HeadquarterService()
